import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { sumFields, toNum } from '@shared/helpers/math.helper';

const SOGLIA_SOCI_FINANZIATORI = 2_000_000;
const SOGLIA_RISERVE_INDIVISIBILI = 4_000_000;
const SOGLIA_VALORE_PRODUZIONE = 60_000_000;

const PRESTITI_SOCI_FINANZIATORI_CAMPI_ANNO2 = ['my_StPaPsD4a2', 'my_StPaPsD4a12'];
const RISERVE_INDIVISIBILI_CAMPI_ANNO2 = ['my_StPaPsAII2', 'my_StPaPsAIII2', 'my_StPaPsAIV2', 'my_StPaPsAV2', 'my_StPaPsAVI2', 'my_StPaPsAVIItot2'];
const VALORE_PRODUZIONE_CAMPI_ANNO2 = ['my_CoEcA12', 'my_CoEcA22', 'my_CoEcA32', 'my_CoEcA42', 'my_CoEcA5tot2'];

/**
 * InfoPath script.vbs `aggiornoEnableCkEnteTenutoCertBil` + `aggiornaCkEnteTenutoCertBil`.
 * Restituisce i campi di my_Bilancio da scrivere: flag di abilitazione e, se almeno una soglia è superata,
 * `my_CkEnteTenutoCertBil = '1'` + la spunta del motivo di ogni soglia superata.
 */
export const calcCertBilancioPatch = (data: MyVerbale): Record<string, string> => {
    const datiBil = data?.my_SezioneI__Rilevazione?.my_DatiBilancio;
    const passivo = datiBil?.my_StatoPatrimoniale__Passivo;

    const prestitiSoci = sumFields(passivo, PRESTITI_SOCI_FINANZIATORI_CAMPI_ANNO2, 0);
    const prestitoSociAltriDati = toNum(datiBil?.my_StatoPatrimoniale__Passivo__AltriDati?.my_DvsSociFinanziam2);

    const criteri: Record<string, boolean> = {
        my_CkCtrlCertifPartecSpA: toNum(data?.my_PartecPiuDi50InSpa) === 1,
        my_CkCtrlCertifPrestitiEConferim: prestitiSoci > SOGLIA_SOCI_FINANZIATORI || prestitoSociAltriDati > SOGLIA_SOCI_FINANZIATORI,
        my_CkCtrlCertifRiserveIndivis: sumFields(passivo, RISERVE_INDIVISIBILI_CAMPI_ANNO2, 0) > SOGLIA_RISERVE_INDIVISIBILI,
        my_CkCtrlCertifValoreProd: sumFields(datiBil?.my_ContoEconomico, VALORE_PRODUZIONE_CAMPI_ANNO2, 0) > SOGLIA_VALORE_PRODUZIONE,
    };

    const patch: Record<string, string> = {};
    Object.entries(criteri).forEach(([ckMotivo, superata]) => {
        if (superata) {
            patch[ckMotivo] = '1';
        }
    });
    const enable = Object.keys(patch).length > 0;
    return { my_EnableCkEnteTenutoCertBil: enable ? 'true' : 'false', ...(enable && { my_CkEnteTenutoCertBil: '1' }), ...patch };
};
